export const RulesHaveBeenPublished = Symbol('RulesHaveBeenPublished');
export type RulesHaveBeenPublished = typeof RulesHaveBeenPublished;
